// src/components/WinningPatternDisplay.js
import React from 'react';
import './WinningPatternDisplay.css'; // Styles will be heavily updated

const BINGO_CARD_LABELS = ['B', 'I', 'N', 'G', 'O'];

function PatternBoard({ pattern }) {
  return (
    <div className="pattern-board-grid">
      {BINGO_CARD_LABELS.map(label => (
        <div key={label} className="pattern-board-header-cell">{label}</div>
      ))}
      {pattern.flat().map((cell, index) => (
        <div
          key={index}
          className={`
            pattern-board-cell
            ${cell === 1 ? 'is-marked-pattern' : ''}
          `}
        >
          {/* No "FREE" text */}
        </div>
      ))}
    </div>
  );
}

function WinningPatternDisplay({ selectedRound, className }) {
  if (!selectedRound || !selectedRound.patterns || selectedRound.patterns.length === 0) {
    return (
      <div className={`${className} winning-patterns-container no-patterns`}>
        <p>No winning patterns defined for this round.</p>
      </div>
    );
  }

  return (
    // Add a class for overall styling if needed, className prop is for App.css animation
    <div className={`${className} winning-patterns-container-themed`}>
      {/* This h2 will be the prominent, centered round title */}
      <h2 className="current-round-title-display">{selectedRound.name}</h2>
      <div className="patterns-grid-container"> {/* New wrapper for the grid */}
        <div className="patterns-grid">
          {selectedRound.patterns.map((patternObj, index) => (
            <div key={index} className="pattern-item">
              {patternObj.label && <h4 className="pattern-label">{patternObj.label}</h4>}
              <PatternBoard pattern={patternObj.board} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WinningPatternDisplay;
